<template>
  <router-view />
</template>

<style lang="less">
html {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

body {
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  color: #333333;
  font-size: 14px;
  font-family:
    "Microsoft YaHei",
    -apple-system,
    "PingFang SC",
    "Helvetica Neue For Number",
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    "Hiragino Sans GB",
    "Helvetica Neue",
    Helvetica,
    Arial,
    sans-serif;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  touch-action: none;
  text-size-adjust: 100% !important;
}

#app {
  width: 100%;
  height: 100%;
}
</style>
